import React from 'react';
import settings from '../settings';
import autoBind from '../modules/autoBind';
import { validations } from 'common';
import Spinner from '../modules/Spinner.jsx';
import Login from './auth/Login.jsx';
import Navbar from './Navbar.jsx';
import ReportingTool from './reports/ReportingTool.jsx';
import Users from './users/Users.jsx';
import Questionnaires from './questionnaires/Questionnaires.jsx';
import QuestionnaireBenziger from './questionnaires/QuestionnaireBenziger.jsx';
import UserDetails from './users/UserDetails.jsx';
import Consultants from './consultants/Consultants.jsx';
import Registration from './registration/Registration.jsx';
import Licenses from './licenses/Licenses.jsx';
import LicenseRequests from './licenses/licenseRequests.jsx';
import './app.scss';
import './auth/TokenManager';

const apiLocation = settings.apiUrl;

export default class App extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      api: null,
      route: window.location.hash.substr(1),
      questionnaire: null
    };

    this.getApi();
    require('moment').locale('es');
  }
  componentDidMount() {
    window.addEventListener('hashchange', () => {
      this.setState({ route: window.location.hash.substr(1) })
    });
  }
  getApi() {
    $.ajax(apiLocation)
    .success((api) => this.setState({ api, loggingOut: false }))
    .fail(() => this.setState({ errorMessage: 'Hubo un error al cargar la aplicación.' }));
  }
  render() {
    if (this.state.loggingOut) {
      return <div>Saliendo...</div>;
    }

    if (this.state.errorMessage) {
      return <div>{this.state.errorMessage}</div>;
    }

    if (!this.state.api) {
      return <center><Spinner/></center>;
    }

    const routeParts = this.state.route.split('/');
    if (this.state.api._rels.questionnaires && routeParts.length > 1 && routeParts[1] === 'cuestionarios') {
      return <Questionnaires resourceUrl={this.state.api._rels.questionnaires.replace('{id}', routeParts[2])} />;
    }

    if (this.state.api._rels.submitBenziger && routeParts.length > 2 && routeParts[1] === 'tomarBenziger') {
      return <QuestionnaireBenziger benzigerProgress={this.state.api._rels.benzigerProgress} qId={routeParts[2]} submitBenziger={this.state.api._rels.submitBenziger}  />;
    }

    if (this.state.api._rels.registration && routeParts.length > 1 && routeParts[1] === 'registro') {
      return <Registration resourceUrl={this.state.api._rels.registration.replace('{id}', routeParts[2])} />;
    }

    if (!this.state.api.user) {
      if (this.state.api._rels.login) {
        return <Login url={this.state.api._rels.login} onLogin={this.getApi}/>;
      }
      return <div>No se puede entrar por el momento.</div>
    }
    
    if (this.state.api.user) {
      return (
        <div>
          <Navbar user={this.state.api.user} onLogout={this.handleLogout} route={this.state.route} />
          <div className='container'>
            {this.getComponent(this.state.route)}
          </div>
        </div>
      );
    }
  }
  handleLogout() {
    window.location.hash = '/';
    this.setState({ api: null, loggingOut: true });
    this.getApi()
  }
  getComponent() {
    const routes = {
      reports: '/reportes',
      users: '/clientes',
      user: '/clientes/:id'
    };

    if (this.state.api.user.userType === 'admin') {
      routes.consultants = '/consultores';
      routes.licenseRequests = '/peticiones';
    }
    
    const routeHandlers = {
      reports: () => <ReportingTool numLicenses={0} user={this.state.api.user} consumeLicense={this.state.api._rels.consumeLicense} xtnaReportTemplate={this.state.api._rels.xtnaReportTemplate} humanFactorsReportTemplate={this.state.api._rels.humanFactorsReportTemplate}/>,
      users: () => <Users userType={this.state.api.user.userType} user={this.state.api.user.username} sendBenziger={this.state.api._rels.sendBenziger} resourceUrl={this.state.api._rels.users.replace('{usertype}', this.state.api.user.userType).replace('{username}', this.state.api.user.username)}/>,        
      user: ({id}) => <UserDetails user={this.state.api.user.username} userType={this.state.api.user.userType} exportBenziger={this.state.api._rels.benzigerAdultTemplate} resourceUrl={this.state.api._rels.getUserById.replace('{id}', id)} />,
      consultants: () => <Consultants resourceUrl={this.state.api._rels.consultants} consultantUrl={this.state.api._rels.getConsultantById} />,
      licenses: () => <Licenses resourceUrl={this.this.state.api._rels.addLicenses} />,
      licenseRequests: () => <LicenseRequests resourceUrl={this.state.api._rels.licenseRequests} />,
    };

    const matchingRoute = this.getMatchingRoute(this.state.route, routes);

    if (!matchingRoute.route) {
      window.location.hash = '/reportes';
      return routeHandlers.reports();
    }

    return routeHandlers[matchingRoute.route](matchingRoute.params);
  }
  getMatchingRoute(route, routes) {
    const forEachIndexed = R.addIndex(R.forEach);
    const currentRouteParts = route.split('/');

    let matchingRoute = null, routeParams = null;
    forEachIndexed((routeName, index) => {
      let parts = routes[routeName].split('/');

      if (matchingRoute || parts.length !== currentRouteParts.length) {
        return;
      }

      const params = {};
      let matching = true;
      forEachIndexed((part, partIndex) => {
        if (!matching) {
          return;
        }

        const currentRoutePart = currentRouteParts[partIndex];
        if (part[0] === ':') {
          params[R.tail(part)] = currentRoutePart;
        } else {
          matching = currentRoutePart === part;
        }
      }, parts);

      if (matching) {
        matchingRoute = routeName;
        routeParams = params;
      }
    }, Object.keys(routes));
    
    return {
      route: matchingRoute,
      params: routeParams
    }
  }
}



// WEBPACK FOOTER //
// ./src/App/App.jsx